import { MarginStatuses } from '../../enums/margin-statuses.enum';

export interface MarginSetupSlice {
    marginId: number | null;
    submittalId: number | null;
    marginStatusId: number;
    contractStartDate: Date | null;
    contractEndDate: Date | null;
    days?: number;
    hoursPerShift: number | null;
    billRate: number | null;
    payRate: number | null;
    overtimeBillRate: number | null;
    overtimePayRate: number | null;
    overtimeRateFactor: number | null;
    holidayBillRate: number | null;
    holidayPayRate: number | null;
    holidayRateFactor: number | null;
    isAllInclusive?: boolean | null;
}

export const initialMarginSetupSlice: MarginSetupSlice = {
    marginId: null,
    submittalId: null,
    marginStatusId: MarginStatuses.Drafting,
    contractStartDate: null,
    contractEndDate: null,
    days: null,
    hoursPerShift: null,
    billRate: null,
    payRate: null,
    overtimeBillRate: null,
    overtimePayRate: null,
    overtimeRateFactor: null,
    holidayBillRate: null,
    holidayPayRate: null,
    holidayRateFactor: null,
    isAllInclusive: null
};
